module.exports = __webpack_public_path__ + "static/media/LeftArrow.a46d528b.svg";